import React from "react";
import {
  ExpressionEntry,
  ExpressionEntryTypes,
  Operand,
  Operator,
} from "@merrie/nmbrs-api";
import { OperandComponent } from "../operand/operand.component";
import { OperatorComponent } from "../operator/operator.component";

export interface IExpressionEntryProperties {
  entry: ExpressionEntry;
}

export const ExpressionEntryComponent: React.FC<IExpressionEntryProperties> = ({
  entry,
}) => {
  switch (entry.type) {
    case ExpressionEntryTypes.EXPRESSION:
      return null;
    case ExpressionEntryTypes.OPERAND:
      return <OperandComponent operand={entry as Operand} total={false} />;
    case ExpressionEntryTypes.OPERATOR:
      return <OperatorComponent operator={entry as Operator} />;
    default:
      return null;
  }
};
